<template>
    <div style="padding: .24rem">
      <titleHead v-if="$local.get('appOs') != '1'" title="送拍声明书" @backEvent="backEvent" :fixed="true" :isOther="true"></titleHead>
<div class="pre-wrap" style="line-height: .46rem;">
ID：<b>{{userID}}</b>
本人：<b>{{realName}}</b>
证件类型：<b>{{certTypeName}}</b>
证件号码：<b>{{idNumber}}</b><br /><b>就委托中威网拍卖事宜，声明如下:</b>

1、本人保证所有送拍拍品来源清晰，符合国家有关法律规定；
2、本人对所有送拍拍品享有完全所有权并对其真实性、合法性负责；
3、本人保证对所有送拍拍品描述是真实、可靠的，在委托拍卖合同签订后至本场拍卖结束后6个月内，如后续出现关于拍品的质量、真伪、瑕疵纠纷等问题，由本人负责澄清及说明，并同意遵守惠州中威网科技有限公司的处理规则，承担相关法律或经济责任。


特此声明！

</div>
    </div>
</template>

<script>
    import popup from '@/components/text/mixin/popup'
    import titleHead from '@/components/common/Title/Thead.vue'
    export default {
      name: "sendInstructions",
      mixins:[popup],
      components: {
        titleHead
      },
      mounted(){
        let post = {
          title : '送拍声明书',
          mark : '3.0'
        }
        try{
          window.webkit.setTitle(JSON.stringify(post));
        }catch(e){
        }
        try{
          window.webkit.messageHandlers.setTitle.postMessage(JSON.stringify(post));
        }catch(e){
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/text/aboutSetting/direction/sendInstructions.vue